<script>
import Dfes from '@/components/Dfes.vue'
export default {
  components: {
    Dfes
  }
}
</script>

<template>
  <Dfes
    document="nfses"
    descriptionDocument="NFSe (s)"
  />
</template>

<style>

</style>
